import { DataSharingConfig } from '@hcworkspace/analytics-portal/data-sharing';
import { environment } from '../../environments/environment';

export const dataSharingConfig: DataSharingConfig = {
  profilesBaseUrl: environment.profilesBaseUrl,
  acceptedConsentTrn: environment.acceptedConsentTrn,
  rejectedConsentTrn: environment.rejectedConsentTrn,
};
